module.exports = __webpack_public_path__ + "img/grejanje_ikonica.6ff61f92.svg";